import { formatApiDate } from "../../utils/formatDate";

/* `DATE · CATEGORY`, as the reference has it. A piece with no publish date
   shows the category alone rather than a placeholder date.

   Shared by the journal index and the article shelf on every other marketing
   page, so an article is dated and filed the same way wherever it appears.
   `categoryFirst` is the shelf's register — `CATEGORY · DATE`, the category in
   ink — where the subject is what a reader scans for and the date is
   secondary. Same two facts, same formatting; only the order and weight. */
const ArticleMeta = ({
  article,
  className = "",
  categoryFirst = false,
  tone = "light",
}) => {
  // `dark` for a reversed-out section: the same two weights in white.
  const dark = tone === "dark";
  const date = formatApiDate(article.publishedAt);
  const dot = (
    <span
      className={`px-2 ${dark ? "text-white/30" : "text-zp-slate/50"}`}
      aria-hidden="true"
    >
      ·
    </span>
  );
  return (
    <p
      className={`font-mono text-[9.5px] uppercase tracking-[0.14em] ${
        dark ? "text-white/50" : "text-zp-slate"
      } ${className}`}
    >
      {categoryFirst ? (
        <>
          <span className={dark ? "text-white" : "text-zp-ink"}>{article.category}</span>
          {date && (
            <>
              {dot}
              {date}
            </>
          )}
        </>
      ) : (
        <>
          {date && (
            <>
              {date}
              {dot}
            </>
          )}
          {article.category}
        </>
      )}
    </p>
  );
};

export default ArticleMeta;
